import styled from "styled-components";

export const ContainerC = styled.div`
  height: 100vh;
  width: 100%;
  background: #fff;
`;
